/**
 * Tâche 1278 (Eric 2026-06-29) — « Le tableau de bord des écarts n'apparaît
 * encore nulle part !! »
 *
 * Il vivait au sommet de la page Transcriptions, invisible pour qui ne
 * cherchait pas les transcriptions. Il a maintenant son entrée de menu et son
 * écran, avec l'injection sur toute la bibliothèque.
 */
import { useNavigate } from "react-router-dom";

import CoverageGapsDashboard from "../components/gaps/CoverageGapsDashboard";
import GapInjectionsJournal from "../components/gaps/GapInjectionsJournal";
import GapsWeeklyEmailToggle from "../components/gaps/GapsWeeklyEmailToggle";
import GapsDigestPreviewButton from "../components/gaps/GapsDigestPreviewButton";
import { useLang } from "../contexts/LanguageContext";

export default function CoverageGapsPage() {
  const { lang } = useLang();
  const navigate = useNavigate();

  return (
    <div className="p-6 max-w-5xl" data-testid="coverage-gaps-page">
      <h1 className="text-2xl font-bold text-zinc-900">
        {lang === "fr" ? "Écarts de transcription" : "Transcript gaps"}
      </h1>
      <p className="text-sm text-zinc-500 mt-1 mb-5">
        {lang === "fr"
          ? "Les vidéos dont la transcription fusionnée a perdu du contenu, classées par minutes manquantes. Les passages entendus par l'autre source peuvent être réinjectés sur toute la bibliothèque."
          : "Videos whose merged transcript lost content, ranked by missing minutes. Passages heard by the other source can be re-injected library-wide."}
      </p>
      <CoverageGapsDashboard
        lang={lang}
        onOpenVideo={(videoId) => navigate(`/dashboard/videos/${videoId}?tab=transcriptions`)}
      />
      {/* Tâches 1281 · 1282 — Ce qui a été injecté, et le courriel du lundi. */}
      <div className="mt-5 space-y-3">
        <GapInjectionsJournal />
        <GapsWeeklyEmailToggle />
        {/* Tâche 1288 — Vérifier la chaîne d'envoi sans attendre lundi. */}
        <GapsDigestPreviewButton />
      </div>
    </div>
  );
}
